module.exports = __webpack_public_path__ + "static/media/topic2.9ef20197.png";